import { useContext } from 'react';

import { FormContext } from './FormContext';
import type { IFormConsumerState } from './IFormConsumerState';

export const useFormContext = <T = unknown>(): IFormConsumerState<T> => {
    return useContext(FormContext) as IFormConsumerState<T>;
};
